{
  "INBOX": {
    "LIST": {
      "TITLE": "Caixa de Entrada",
      "DISPLAY_DROPDOWN": "Exibir",
      "LOADING": "Carregando notificações",
      "404": "Não há conversas ativas neste grupo.",
      "NO_NOTIFICATIONS": "Nenhuma notificação",
      "NOTE": "Notificações de todas as caixas inscritas",
      "NO_MESSAGES_AVAILABLE": "Ops! Não é possível obter mensagens",
      "SNOOZED_UNTIL": "Adiar até",
      "SNOOZED_UNTIL_TOMORROW": "Adiado até amanhã",
      "SNOOZED_UNTIL_NEXT_WEEK": "Adiada até a próxima semana"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Adiar notificação",
      "DELETE": "Excluir notificação",
      "BACK": "Anterior"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Você foi mencionado em uma conversa",
      "CONVERSATION_CREATION": "Nova conversa criada",
      "CONVERSATION_ASSIGNMENT": "Uma conversa foi atribuída a você",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova mensagem em uma conversa atribuída",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nova mensagem em uma conversa na qual você participa",
      "SLA_MISSED_FIRST_RESPONSE": "Primeira resposta da meta de SLA perdida na conversa",
      "SLA_MISSED_NEXT_RESPONSE": "Próxima resposta da meta de SLA perdida na conversa",
      "SLA_MISSED_RESOLUTION": "A resolução da meta de SLA foi perdida na conversa"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Mencionado",
      "CONVERSATION_ASSIGNMENT": "Atribuídas a você",
      "CONVERSATION_CREATION": "Nova conversa",
      "SLA_MISSED_FIRST_RESPONSE": "Quebra SLA",
      "SLA_MISSED_NEXT_RESPONSE": "Quebra SLA",
      "SLA_MISSED_RESOLUTION": "Quebra SLA",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nova Mensagem",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova Mensagem",
      "SNOOZED_UNTIL": "Adiado para {time}",
      "SNOOZED_ENDS": "Adiamento encerrado"
    },
    "NO_CONTENT": "Nenhum conteúdo disponível",
    "MENU_ITEM": {
      "MARK_AS_READ": "Marcar como lida",
      "MARK_AS_UNREAD": "Marcar como não lida",
      "SNOOZE": "Adiar",
      "DELETE": "Excluir",
      "MARK_ALL_READ": "Marcar todas como lidas",
      "DELETE_ALL": "Excluir todas",
      "DELETE_ALL_READ": "Excluir todas as lidas"
    },
    "DISPLAY_MENU": {
      "SORT": "Ordenar",
      "DISPLAY": "Exibir:",
      "SORT_OPTIONS": {
        "NEWEST": "Recentes",
        "OLDEST": "Antigas",
        "PRIORITY": "Prioridade"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Adiadas",
        "READ": "Lida",
        "LABELS": "Etiquetas",
        "CONVERSATION_ID": "ID da conversa"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Notificação marcada como lida",
      "MARK_AS_UNREAD": "Notificação marcada como não lida",
      "SNOOZE": "Notificação adiada",
      "DELETE": "Notificação excluída",
      "MARK_ALL_READ": "Todas as notificações marcadas como lidas",
      "DELETE_ALL": "Todas as notificações excluídas",
      "DELETE_ALL_READ": "Todas as notificações lidas foram excluídas"
    },
    "REAUTHORIZE": {
      "TITLE": "Reautenticação necessária",
      "DESCRIPTION": "Sua conexão com o WhatsApp expirou. Por favor, reconecte para continuar recebendo e enviando mensagens.",
      "BUTTON_TEXT": "Reconectar WhatsApp",
      "LOADING_FACEBOOK": "Carregando SDK do Facebook...",
      "SUCCESS": "WhatsApp reconectado com sucesso",
      "ERROR": "Falha ao reconectar o WhatsApp. Por favor, tente novamente.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID não está configurado. Por favor, contate seu administrador.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID não está configurado. Por favor, contate seu administrador.",
      "CONFIGURATION_ERROR": "Ocorreu um erro de configuração ao reautenticar.",
      "FACEBOOK_LOAD_ERROR": "Falha para carregar o SDK do Facebook. Por favor, tente novamente.",
      "TROUBLESHOOTING": {
        "TITLE": "Solucionar problemas",
        "POPUP_BLOCKED": "Certifique-se de que os pop-ups são permitidos para este site",
        "COOKIES": "_Cookies_ de terceiros devem estar habilitados",
        "ADMIN_ACCESS": "Você precisa de acesso de administrador na conta do WhatsApp Business"
      }
    }
  }
}
